// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/infos-zur-aktuellen-lage/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const infosZurAktuellenLageDE: PageEntry = {
  id: "post.infos-zur-aktuellen-lage",
  locale: "de",
  slug: "infos-zur-aktuellen-lage",
  seo: {
    title: "Infos zur aktuellen Lage | Dietz GmbH",
    description: "Infos zur aktuellen Lage",
  },
  type: "post",
  h1: "Infos zur aktuellen Lage",
  blocks: [
    { kind: "heading", level: 2, text: "Infos zur aktuellen Lage" },
    { kind: "paragraph", text: "29.04.2020" },
    { kind: "paragraph", text: "Liebe Kundinnen und Kunden, liebe DIETZ-Lieferanten," },
    { kind: "paragraph", text: "wir haben in unserem Unternehmen ein komplettes Pandemiemanagement eingeführt und sind wieder komplett für Sie da." },
    { kind: "paragraph", text: "Die Fertigung läuft, Ihre gewohnten Ansprechpartner stehen zur Verfügung." },
    { kind: "paragraph", text: "Sollten Sie aufgrund von Homeoffice und Kurzarbeit dennoch den gewohneten Ansprechpartner nicht erreichen, so senden Sie bitte eine Email an" },
    { kind: "list", items: ["info@dietz.eu"] },
    { kind: "paragraph", text: "oder" },
    { kind: "list", items: ["sales@dietz.eu"] },
    { kind: "paragraph", text: "Wir kümmern uns schnellstmöglich um Ihr Anliegen." },
    { kind: "paragraph", text: "Bleiben Sie gesund." },
    { kind: "paragraph", text: "Ihr Matthias Dietz" },
    { kind: "paragraph", text: "31.03.2020" },
    { kind: "paragraph", text: "viele unserer Kunden haben ihre Werke bereits geschlossen oder beabsichtigen dies über Ostern umzusetzen. Schweren Herzens müssen auch wir uns anschließen, da mit dem Wegfall der eigentlich anstehenden Lieferungen der Arbeitsanfall wegbricht." },
    { kind: "paragraph", text: "Unser Unternehmen ist deshalb in der Zeit vom 06.04.2020 bis einschließlich 09.04.2020 geschlossen." },
    { kind: "paragraph", text: "Wir nutzen die Zeit, die IT und Kommunikationsinfrastruktur zu verbessern und den Neubau an den Bestand anzuschließen." },
    { kind: "paragraph", text: "In dieser Zeit ist keine Warenannahme und auch kein Versand von Waren möglich." },
    { kind: "paragraph", text: "In dringenden Fällen erreichen Sie uns in der oben genannten Woche:" },
    { kind: "list", items: ["per Telefon unter +49 (0) 9568 9442-700 und insbesondere, falls Sie uns telefonisch nicht gleich erreichen:", "per E-Mail unter matthias.dietz@dietz.eu"] },
    { kind: "paragraph", text: "Helfen Sie mit, die CORONA-Pandemie zu stoppen." },
    { kind: "paragraph", text: "Bleiben Sie zu Hause und bleiben Sie gesund." },
    { kind: "paragraph", text: "23.03.2020" },
    { kind: "paragraph", text: "die aktuelle Situation stellt uns alle vor große Herausforderungen und wir möchten Ihnen heute das klare Signal senden, dass wir trotz aller Einschränkungen des öffentlichen Lebens für Sie weiterhin vor Ort tätig bleiben. Ein großer Teil unseres Teams, das im Werk tätig ist, tut seine Arbeit in gewohnter Weise dort. Alle anderen, die aus dem Home Office arbeiten können, sind von dort für Sie da." },
    { kind: "paragraph", text: "Sie erreichen uns auf den üblichen Wegen:" },
    { kind: "list", items: ["per Telefon unter +49 (0) 9568 9442-100 und insbesondere, falls Sie uns telefonisch nicht gleich erreichen:", "per E-Mail unter info@dietz.eu"] },
    { kind: "paragraph", text: "An dieser Stelle werden wir Sie künftig über aktuelle Änderungen informieren." },
    { kind: "paragraph", text: "Schauen Sie von Zeit zu Zeit mal rein." },
    { kind: "paragraph", text: "Achten Sie auf sich und Ihre Mitmenschen – wir bleiben für Sie da – bleiben Sie gesund." },
    { kind: "paragraph", text: "Ihr Team von Dietz" }
  ],
};
